import { render, staticRenderFns } from "./MainTowerCard.vue?vue&type=template&id=1dc12a4c&scoped=true&"
import script from "./MainTowerCard.vue?vue&type=script&lang=js&"
export * from "./MainTowerCard.vue?vue&type=script&lang=js&"
import style0 from "./MainTowerCard.vue?vue&type=style&index=0&id=1dc12a4c&lang=less&scoped=true&"
import style1 from "./MainTowerCard.vue?vue&type=style&index=1&id=1dc12a4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc12a4c",
  null
  
)

export default component.exports